import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Button, Row, Col } from 'react-bootstrap';
import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';

import UnaccountedHoursTicketsTable from './Table';
import { getEndDateApiFormat, getStartDateApiFormat } from '../selectors';
import { getApiServerUrl } from '../../configuration/selectors';
import linkWithCredentials from '../../../utils/linkWithCredentials';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';


const propTypes = exact({
  apiStartDate: PropTypes.string,
  apiEndDate: PropTypes.string,
  apiServerUrl: PropTypes.string.isRequired,
});


const TableView = (props) => {
  const {
    apiServerUrl,
    apiStartDate,
    apiEndDate,
  } = props;

  const openUrl = () => {
    const csvUrl = linkWithCredentials(`${apiServerUrl}/unaccounted_hours_tickets`);
    downloadingFileAndUpdatingCredentials(`${csvUrl}&start_date=${apiStartDate}&end_date=${apiEndDate}&with_headings=true`);
  };

  return (
    <React.Fragment>
      <Row className="">
        <Col md={12}>
          <Button
            onClick={openUrl}
            bsStyle="primary"
            className="pull-right"
          >Download Report
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <UnaccountedHoursTicketsTable startDate={apiStartDate} endDate={apiEndDate} />
        </Col>
      </Row>
    </React.Fragment>
  );
};


TableView.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    apiStartDate: getStartDateApiFormat(state),
    apiEndDate: getEndDateApiFormat(state),
    apiServerUrl: getApiServerUrl(state),
  };
};

const withRedux = connect(mapStateToProps, {});


const withNoStartOrEndDate = branch(
  (props) => { return !props.apiStartDate || !props.apiEndDate; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withNoStartOrEndDate,
);

export default enhance(TableView);
